import { useId } from "react";
import Marquee from "react-fast-marquee";
import { Star } from "lucide-react";
import { Reveal } from "./Reveal";

// NOTE: contenido de muestra — sustituir por reseñas reales cuando haya clientes.
const reviews = [
  {
    id: "panaderia-la-espiga",
    business: "Panadería La Espiga",
    text: "Por fin nos encuentran en Google. En una semana teníamos la web lista y empezamos a recibir pedidos.",
    stars: 5,
  },
  {
    id: "clinica-dental-sonrie",
    business: "Clínica Dental Sonríe",
    text: "El botón de cita online nos ha cambiado la vida. Trato cercano y todo clarísimo desde el principio.",
    stars: 5,
  },
  {
    id: "taller-mecanico-nova",
    business: "Taller Mecánico Nova",
    text: "No teníamos nada online y ahora tenemos una web profesional. Rápidos y sin sorpresas en el precio.",
    stars: 5,
  },
  {
    id: "peluqueria-estilo",
    business: "Peluquería Estilo",
    text: "La galería quedó preciosa y los clientes nos escriben directamente desde la web. Muy recomendables.",
    stars: 5,
  },
];

const Card = ({ r }) => {
  // Marquee renders multiple copies; each instance needs distinct DOM test IDs.
  const instanceId = useId().replace(/:/g, "");
  const testId = `testimonial-${r.id}-${instanceId}`;
  return (
  <div data-testid={testId} className="mx-4 flex w-[280px] flex-col justify-between rounded-2xl border border-white/10 bg-[#101018] p-7 sm:w-[340px]">
    <div>
      <div data-testid={`${testId}-rating`} aria-label={`${r.stars} de 5 estrellas`} className="flex gap-1">
        {[1, 2, 3, 4, 5].slice(0, r.stars).map((rating) => (
          <Star key={`${r.id}-star-${rating}`} aria-hidden="true" className="h-4 w-4 fill-[#00E5FF] text-[#00E5FF]" />
        ))}
      </div>
      <p data-testid={`${testId}-text`} className="mt-5 text-base leading-relaxed text-zinc-300">“{r.text}”</p>
    </div>
    <div data-testid={`${testId}-business`} className="mt-6 font-head text-sm font-semibold text-white">{r.business}</div>
  </div>
  );
};

export const Testimonials = () => (
  <section id="resenas" data-testid="testimonials-section" className="relative py-24 md:py-32">
    <Reveal className="mx-auto mb-14 max-w-7xl px-5 md:px-10">
      <span className="text-sm font-medium uppercase tracking-[0.25em] text-[#00E5FF]">05 — Reseñas</span>
      <h2 className="mt-5 font-head text-4xl font-light leading-tight tracking-tight text-white sm:text-5xl">
        Lo que dicen los <span className="font-black">negocios</span>
      </h2>
      <p data-testid="testimonials-sample-notice" className="mt-3 text-sm text-zinc-500">Contenido de muestra · se sustituirá por reseñas reales.</p>
    </Reveal>

    <Marquee gradient gradientColor="#0A0A0C" gradientWidth={120} speed={40} pauseOnHover>
      {reviews.map((r) => (
        <Card key={r.id} r={r} />
      ))}
    </Marquee>
  </section>
);

export const MarqueeBand = () => (
  <div className="border-y border-white/10 py-6" data-testid="marquee-band">
    <Marquee gradient gradientColor="#0A0A0C" gradientWidth={80} speed={55}>
      {["Diseño web para negocios", "Presencia online 24/7", "Página web profesional", "Que te encuentren", "Que te elijan", "Que te recomienden"].map(
        (t) => (
          <span key={t} className="mx-8 font-head text-3xl font-light text-white/40 sm:text-4xl">
            {t} <span className="mx-8 text-[#00E5FF]">✦</span>
          </span>
        )
      )}
    </Marquee>
  </div>
);
